export enum ActionType {
    undefined = 0,
    updateEntityItem = 1,
    includeDocumentInCaseFile = 2
}